import { render, staticRenderFns } from "./AppArticle.vue?vue&type=template&id=645e3698&"
import script from "./AppArticle.vue?vue&type=script&lang=js&"
export * from "./AppArticle.vue?vue&type=script&lang=js&"
import style0 from "./AppArticle.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports